// formatMoney function (copied from theme.js.liquid)
function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || window.themeVariables.settings.moneyFormat;
  
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split(".");
    let dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    let centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

const target = document.getElementById('delivery_time_input');
const static_target = document.getElementById('delivery_time_input_static');
document.addEventListener('variant:change', function(event) {
    let variantId = event.detail.variant.id;
    let currentQty = varQty[variantId];
    let msg = '';
    if ( currentQty > 0) {
        msg = varInStock[variantId];
    } else {
        msg = varOutStock[variantId];
    }
    if (typeof msg !== 'undefined') {
        target.disabled = false;
        static_target.disabled = false;
        target.value = msg;
        static_target.value = msg;
    } else {
        target.value = '';
        static_target.value = '';
        target.disabled = true;
        static_target.disabled = true;
    }
  });

  const frameContainer = document.getElementById("frame-addon-selector");
  
  // Only proceed if frame container exists
  if (frameContainer) {
    // Function to get current variant object (for price and compare_at_price)
    function getCurrentVariant() {
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return null;

      const formId = variantPicker.getAttribute('form');
      if (!formId) return null;

      const productForm = document.getElementById(formId);
      if (!productForm) return null;

      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (!variantIdInput || !variantIdInput.value) return null;

      const variantId = parseInt(variantIdInput.value, 10);

      if (variantPicker.product && variantPicker.product.variants) {
        return variantPicker.product.variants.find(function (v) { return v.id === variantId; }) || null;
      }
      return null;
    }

    // Function to update buy button price with frame price
    function updateBuyButtonPrice() {
      const buyButtonPriceSpan = document.getElementById("buy-button-price");
      if (!buyButtonPriceSpan) {
        return;
      }

      const variant = getCurrentVariant();
      if (!variant) return;

      let totalPrice = variant.price; // Price in cents

      let framePriceCents = 0;
      const selectedInput = frameContainer.querySelector('input[name="frame-addon"]:checked');
      if (selectedInput && selectedInput.id === "frame-addon-with") {
        const selectedFrame = frameContainer.querySelector('img[data-selected="true"]');
        if (selectedFrame && selectedFrame.dataset.framePriceCents) {
          framePriceCents = parseInt(selectedFrame.dataset.framePriceCents, 10);
          totalPrice = variant.price + framePriceCents;
        }
      }

      // Compare-at (original) price: add frame to variant's compare_at_price when frame is selected
      const baseCompareAtPrice = variant.compare_at_price || 0;
      const totalCompareAtPrice = baseCompareAtPrice > 0 ? baseCompareAtPrice + framePriceCents : 0;
      const showCompareAt = totalCompareAtPrice > totalPrice;

      // Format and update the price
      const currencyFormat = window.themeVariables?.settings?.currencyCodeEnabled 
        ? window.themeVariables.settings.moneyWithCurrencyFormat 
        : window.themeVariables.settings.moneyFormat;

      const formattedPrice = formatMoney(totalPrice, currencyFormat);
      buyButtonPriceSpan.textContent = formattedPrice;

      const variantPicker = document.querySelector('variant-picker');
      const formId = variantPicker?.getAttribute('form');
      if (formId) {
        // Sync sale price element(s) at the top with the same total (variant + frame)
        const salePriceElements = document.querySelectorAll('sale-price[form="' + formId + '"]');
        salePriceElements.forEach(function (el) {
          if (el.lastChild) {
            el.lastChild.replaceWith(document.createRange().createContextualFragment(formattedPrice));
          }
        });

        // Sync compare-at (original) price: update value and visibility
        const compareAtPriceElements = document.querySelectorAll('compare-at-price[form="' + formId + '"]');
        if (showCompareAt && totalCompareAtPrice > 0) {
          const formattedCompareAt = formatMoney(totalCompareAtPrice, currencyFormat);
          compareAtPriceElements.forEach(function (el) {
            if (el.lastChild) {
              el.lastChild.replaceWith(document.createRange().createContextualFragment(formattedCompareAt));
            }
            el.hidden = false;
          });
        } else {
          compareAtPriceElements.forEach(function (el) {
            el.hidden = true;
          });
        }
      }
    }

    // Listen to changes inside the frame container fieldset
    frameContainer.addEventListener("change", function (event) {
      // Only handle changes to frame-addon radio buttons
      if (!event.target.name || event.target.name !== "frame-addon") {
        return;
      }

      const selectedInput = frameContainer.querySelector('input[name="frame-addon"]:checked');
      const optionTitle = frameContainer.querySelector('variant-option-value');

      if (selectedInput) {
        // Clear all previously selected
        frameContainer.querySelectorAll("div.custom-option-img").forEach((label) => {
          label.removeAttribute("data-selected");
        });
        
        // Set on newly selected
        const label = document.querySelector(`label[for="${selectedInput.id}"]`);
        const frameWrapper = label.querySelector("div.custom-option-img");
        if (label) {
          frameWrapper.setAttribute("data-selected", "true");
          const selectedFrame = frameContainer.querySelector('img[data-selected="true"]');
          if (label.dataset.type == "with") {
            const framePrice = selectedFrame.dataset.framePrice;
            optionTitle.textContent = selectedInput.value + " +" + framePrice;
          } else {
            optionTitle.textContent = selectedInput.value;
          }
        }
        
        // Update buy button price
        updateBuyButtonPrice();
      }
    });

    // Listen to variant changes to update prices
    document.addEventListener("variant:change", function(event) {
      if (event.detail && event.detail.variant) {
        updateBuyButtonPrice();
      }
    });

    // Initialize on page load
    setTimeout(updateBuyButtonPrice, 500);
  }

// SOLWE: hide the "Available now" badge while the selected variant is sold out - CUSTOMIZATIONS.md #3
if (!window.customElements.get("available-now-badge")) {
  window.customElements.define("available-now-badge", class extends HTMLElement {
    connectedCallback() {
      this._form = document.forms[this.getAttribute("form")];
      this._onVariantChanged = (event) => {
        const variant = event.detail && event.detail.variant;
        this.hidden = !variant || !variant.available;
      };
      this._form?.addEventListener("variant:change", this._onVariantChanged);
    }
    disconnectedCallback() {
      this._form?.removeEventListener("variant:change", this._onVariantChanged);
    }
  });
}
// /SOLWE
  
// HI engine A/B test exp-d0d81744: on phones, the 90-day trial and free
// delivery lines move up to sit right under Add to cart and the delivery-time
// line. Runs only for the variant arm (body.hi-exp-exp-d0d81744). Computers
// keep today's layout.
(function () {
  var VARIANT = 'hi-exp-exp-d0d81744';
  var phone = window.matchMedia('(max-width: 999px)');
  var spots = [];

  function place() {
    if (!document.body || !document.body.classList.contains(VARIANT)) return;
    document.querySelectorAll('.product-info > .product-info__inventory').forEach(function (inventory) {
      var offer = inventory.parentElement.querySelector(':scope > .product-info__inventory ~ .offer');
      if (!offer || offer.hiHome) return;
      offer.hiHome = document.createComment('hi-exp-d0d81744 home');
      offer.before(offer.hiHome);
      spots.push({ offer: offer, inventory: inventory });
    });
    spots.forEach(function (spot) {
      if (phone.matches) {
        if (spot.inventory.nextElementSibling !== spot.offer) spot.inventory.after(spot.offer);
      } else if (spot.offer.hiHome.nextSibling !== spot.offer) {
        spot.offer.hiHome.after(spot.offer);
      }
    });
  }

  function start() {
    place();
    phone.addEventListener('change', place);
    // The loader adds the variant class when PostHog assigns the visitor.
    new MutationObserver(place).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
